import { History } from "history";

import {
  CreateSchoolRequest,
  PaginateQuery,
  UpdateSchoolRequest,
  SchoolDto,
} from "../../interfaces";
import { Paginated, SelectListDto } from "../../models";

//#region Get Schools

export const GET_SCHOOLS = "GET_SCHOOLS";
export const GET_SCHOOLS_SUCCESS: any = "GET_SCHOOLS_SUCCESS";
export const GET_SCHOOLS_ERROR: any = "GET_SCHOOLS_ERROR";

export interface GetSchoolsAction {
  type: typeof GET_SCHOOLS;
  payload: {
    request: PaginateQuery;
    history: History;
  };
}

export interface GetSchoolsSuccessAction {
  type: typeof GET_SCHOOLS_SUCCESS;
  payload: Paginated<SchoolDto>;
}

export interface GetSchoolsErrorAction {
  type: typeof GET_SCHOOLS_ERROR;
  payload: any;
}
//#endregion

//#region Get School

export const GET_SCHOOL = "GET_SCHOOL";
export const GET_SCHOOL_SUCCESS: any = "GET_SCHOOL_SUCCESS";
export const GET_SCHOOL_ERROR: any = "GET_SCHOOL_ERROR";

export interface GetSchoolAction {
  type: typeof GET_SCHOOL;
  payload: {
    id: string;
    history: History;
  };
}

export interface GetSchoolSuccessAction {
  type: typeof GET_SCHOOL_SUCCESS;
  payload: SchoolDto;
}

export interface GetSchoolErrorAction {
  type: typeof GET_SCHOOL_ERROR;
  payload: any;
}
//#endregion

//#region Get School Select List

export const GET_SCHOOL_SELECT_LIST = "GET_SCHOOL_SELECT_LIST";
export const GET_SCHOOL_SELECT_LIST_SUCCESS: any =
  "GET_SCHOOL_SELECT_LIST_SUCCESS";
export const GET_SCHOOL_SELECT_LIST_ERROR: any = "GET_SCHOOL_SELECT_LIST_ERROR";
export const RESET_SCHOOL_SELECT_LIST: any = "RESET_SCHOOL_SELECT_LIST";

export interface GetSchoolSelectListAction {
  type: typeof GET_SCHOOL_SELECT_LIST;
  payload: {
    governorateId: string;
    cityId: string;
    history: History;
  };
}

export interface GetSchoolSelectListSuccessAction {
  type: typeof GET_SCHOOL_SELECT_LIST_SUCCESS;
  payload: SelectListDto[];
}

export interface GetSchoolSelectListErrorAction {
  type: typeof GET_SCHOOL_SELECT_LIST_ERROR;
  payload: any;
}

export interface ResetSchoolSelectListAction {
  type: typeof RESET_SCHOOL_SELECT_LIST;
  payload: any;
}
//#endregion

//#region Add School

export const ADD_SCHOOL = "ADD_SCHOOL";
export const ADD_SCHOOL_SUCCESS: any = "ADD_SCHOOL_SUCCESS";
export const ADD_SCHOOL_ERROR: any = "ADD_SCHOOL_ERROR";

export interface AddSchoolAction {
  type: typeof ADD_SCHOOL;
  payload: {
    request: CreateSchoolRequest;
    history: History;
  };
}

export interface AddSchoolSuccessAction {
  type: typeof ADD_SCHOOL_SUCCESS;
  payload: null;
}

export interface AddSchoolErrorAction {
  type: typeof ADD_SCHOOL_ERROR;
  payload: any;
}
//#endregion

//#region Update School

export const UPDATE_SCHOOL = "UPDATE_SCHOOL";
export const UPDATE_SCHOOL_SUCCESS: any = "UPDATE_SCHOOL_SUCCESS";
export const UPDATE_SCHOOL_ERROR: any = "UPDATE_SCHOOL_ERROR";

export interface UpdateSchoolAction {
  type: typeof UPDATE_SCHOOL;
  payload: {
    id: string;
    request: UpdateSchoolRequest;
    history: History;
  };
}

export interface UpdateSchoolSuccessAction {
  type: typeof UPDATE_SCHOOL_SUCCESS;
  payload: null;
}

export interface UpdateSchoolErrorAction {
  type: typeof UPDATE_SCHOOL_ERROR;
  payload: any;
}
//#endregion

//#region Delete School

export const DELETE_SCHOOL_CONSENT: any = "DELETE_SCHOOL_CONSENT";
export const DELETE_SCHOOL = "DELETE_SCHOOL";
export const DELETE_SCHOOL_SUCCESS: any = "DELETE_SCHOOL_SUCCESS";
export const DELETE_SCHOOL_ERROR: any = "DELETE_SCHOOL_ERROR";

export interface DeleteSchoolConsentAction {
  type: typeof DELETE_SCHOOL_CONSENT;
  payload: string;
}

export interface DeleteSchoolAction {
  type: typeof DELETE_SCHOOL;
  payload: {
    id: string;
    history: History;
  };
}

export interface DeleteSchoolSuccessAction {
  type: typeof DELETE_SCHOOL_SUCCESS;
  payload: null;
}

export interface DeleteSchoolErrorAction {
  type: typeof DELETE_SCHOOL_ERROR;
  payload: any;
}
//#endregion

// Export a union type that represents all possible actions
export type ActionTypes =
  | GetSchoolsAction
  | GetSchoolsSuccessAction
  | GetSchoolsErrorAction
  | GetSchoolAction
  | GetSchoolSuccessAction
  | GetSchoolErrorAction
  | GetSchoolSelectListAction
  | GetSchoolSelectListSuccessAction
  | GetSchoolSelectListErrorAction
  | AddSchoolAction
  | AddSchoolSuccessAction
  | AddSchoolErrorAction
  | UpdateSchoolAction
  | UpdateSchoolSuccessAction
  | UpdateSchoolErrorAction
  | DeleteSchoolConsentAction
  | DeleteSchoolAction
  | DeleteSchoolSuccessAction
  | DeleteSchoolErrorAction
  | ResetSchoolSelectListAction;
